/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Target_Group_HelpInputs */

const en_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The target group is used to populate the target events for translation.`)
};

const fr_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe cible est utilise pour remplir les evenements cibles pour la traduction.`)
};

const de_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zielgruppe dient dazu, die Zielereignisse für die Übersetzung zu ermitteln.`)
};

const it_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo target viene utilizzato per popolare gli eventi target per la traduzione.`)
};

const ru_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая группа используется для заполнения целевых событий, подлежащих переводу.`)
};

const es_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de destino se utiliza para completar los eventos de destino para la traducción.`)
};

const zh_cn2_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标群体用于填充要翻译的目标事件。`)
};

const ja_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲット グループは、翻訳のターゲット イベントを入力するために使用されます。`)
};

const hi_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद के लिए लक्षित घटनाओं को भरने के लिए लक्षित समूह का उपयोग किया जाता है।`)
};

const pt_pt2_translation_merge_target_group_help = /** @type {(inputs: Translation_Merge_Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo-alvo é usado para preencher os eventos-alvo para tradução.`)
};

/**
* | output |
* | --- |
* | "The target group is used to populate the target events for translation." |
*
* @param {Translation_Merge_Target_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_target_group_help = /** @type {((inputs?: Translation_Merge_Target_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Target_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_target_group_help(inputs)
	if (locale === "de") return de_translation_merge_target_group_help(inputs)
	if (locale === "it") return it_translation_merge_target_group_help(inputs)
	if (locale === "ru") return ru_translation_merge_target_group_help(inputs)
	if (locale === "es") return es_translation_merge_target_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_target_group_help(inputs)
	if (locale === "ja") return ja_translation_merge_target_group_help(inputs)
	if (locale === "hi") return hi_translation_merge_target_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_target_group_help(inputs)
	return en_translation_merge_target_group_help(inputs)
});